import type { ErrorDescription } from 'types/handled_error';

export const pharmaciesHandledErrors: ErrorDescription[] = [
  {
    endpoint: 'pharmacies/trades/konnect/pms_config/_finish_onboarding',
    method: 'post',
    responseStatus: 400,
    error: 'finess_not_found',
  },
  {
    endpoint: 'pharmacies/trades/konnect/pms_config/_finish_onboarding',
    method: 'post',
    responseStatus: 400,
    error: 'siret_not_found',
  },
  {
    endpoint: 'pharmacies/trades/_request_print_poster_url',
    method: 'post',
    responseStatus: 400,
    error: 'pharmacy_not_found_in_pnr',
  },
];
